const profileTypes = {
  GET_PROFILE: 'GET_PROFILE',
  SET_PROFILE: 'SET_PROFILE',
  EDIT_PROFILE: 'EDIT_PROFILE',
  GET_CENTERS: 'GET_CENTERS',
  SET_CENTERS: 'SET_CENTERS'
};

export default profileTypes;
